/**
 * Replaces spaces and newlines with their Encoding
 * @param {string} unformatted
 * @returns {string}
 */
const replaceWhitespace = (unformatted) => unformatted.replace(/ /g, "%20").replace(/\n/g, "%0d");

/**
 * Creates an email link
 * @param {Object} params
 * @param {string} params.recipientList="" ex) "sewp.nasa.gov; dev@sewp.nasa.gov; help@sewp.nasa.gov;"
 * @param {string} [params.ccList]
 * @param {string} [params.bccList]
 * @param {string} [params.subject]
 * @param {string} [params.body]
 * @returns {string} email link
 */
export const generateEmail = ({ recipientList, ccList, bccList, subject, body }) => {
  let emailLink = `mailto:${recipientList}`;
  if (!ccList && !bccList && !subject && !body) {
    return emailLink;
  } else {
    emailLink += "?";
    let needsAnd = false;

    if (ccList) {
      emailLink += `cc=${ccList}`;
      needsAnd = true;
    }
    if (bccList) {
      emailLink += `${needsAnd ? "&" : ""}bcc=${bccList}`;
      needsAnd = true;
    }
    if (subject) {
      emailLink += `${needsAnd ? "&" : ""}subject=${replaceWhitespace(subject)}`;
      needsAnd = true;
    }
    if (body) {
      emailLink += `${needsAnd ? "&" : ""}body=${replaceWhitespace(body)}`;
    }

    return emailLink;
  }
};
